import createReducer from 'redux/createReducer';
import { GET_DELIVERY_STATUS } from 'redux/modules/orders/actions/types';
import { DeliveryStatusResponse } from 'api/definitions/delivery-tracking';
import { ApiError } from 'constants/errors';
import initialState, { DeliveryTrackingState } from './initial-state';

interface Action {
  orderId: string;
}

export const getDeliveryStatusLoading: ApiRequestReducer<DeliveryTrackingState, Action> = (
  state,
  action,
) => {
  if (!action.orderId) {
    return state;
  }

  const { deliveryStatuses, ...rest } = state;

  return {
    ...rest,
    deliveryStatuses: {
      ...deliveryStatuses,
      [action.orderId]: deliveryStatuses[action.orderId]
        ? deliveryStatuses[action.orderId]
        : {
            ...deliveryStatuses[action.orderId],
            loading: true,
            loaded: false,
            error: false,
          },
    },
  };
};

export const getDeliveryStatusLoaded: ApiSuccessReducer<
  DeliveryTrackingState,
  Action,
  DeliveryStatusResponse
> = (state, action) => {
  if (!action?.payload?.customerOrderId) {
    return state;
  }

  const { deliveryStatuses, ...rest } = state;

  const {
    customerOrderId,
    status,
    etaStartDateTime = undefined,
    etaEndDateTime = undefined,
    wismoEtaStartDateTime = undefined,
    wismoEtaEndDateTime = undefined,
    runningLate = false,
    driverName = undefined,
  } = action.payload;

  return {
    ...rest,
    deliveryStatuses: {
      ...deliveryStatuses,
      [customerOrderId]: {
        customerOrderId,
        status,
        etaStartDateTime,
        etaEndDateTime,
        wismoEtaStartDateTime,
        wismoEtaEndDateTime,
        runningLate,
        driverName,
        loaded: true,
        loading: false,
        error: false,
        lastUpdated: new Date().toISOString(),
      },
    },
  };
};

export const getDeliveryStatusFailed: ApiErrorReducer<DeliveryTrackingState, Action, ApiError> = (
  state,
  action,
) => {
  if (!action.orderId) {
    return state;
  }

  const { deliveryStatuses, ...rest } = state;

  return {
    ...rest,
    deliveryStatuses: {
      ...deliveryStatuses,
      [action.orderId]: {
        ...deliveryStatuses[action.orderId],
        loaded: true,
        loading: false,
        error: true,
      },
    },
  };
};

const actionTypeReducerMap = [
  [GET_DELIVERY_STATUS.request, getDeliveryStatusLoading],
  [GET_DELIVERY_STATUS.success, getDeliveryStatusLoaded],
  [GET_DELIVERY_STATUS.failure, getDeliveryStatusFailed],
] as const;

export type PayloadMap = ReducerMapTupleToRecord<typeof actionTypeReducerMap>;

export default createReducer(initialState, actionTypeReducerMap);
